import React from 'react'
import { CreditApplication } from '_gql'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'

import { StatusButtons } from '@sputnik/components'
import ImageWrapper from '@sputnik/components/ImageWrapper'
import StatusTile from '@sputnik/pages/Dashboard/StatusTile/StatusTile'
import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'
import { URL } from '@sputnik/resources/constants'
import { logInfo } from '@sputnik/utils/loggerUtils'

import styles from './styles.module.scss'

interface CompanyBuiltStatusTileProps {
  creditApp: CreditApplication
}

const CompanyBuiltStatusTile = ({ creditApp }: CompanyBuiltStatusTileProps) => {
  const { statusUpdatedAt } = creditApp || {}
  const [getClassName, makeTestId] = useNameFormatter('CompanyBuiltStatusTile')

  return (
    <div
      className={styles[getClassName('')]}
      data-testid={makeTestId('')}
    >
      <StatusTile
        creditApp={creditApp}
        image={
          <ImageWrapper
            alt='person with party hat with hands in the air'
            imageName='dashboard-application-approved-status'
          />
        }
        primaryInfo={
          <FormattedMessage
            defaultMessage='Log in to your {BILL_SPEND_AND_EXPENSE} account now.'
            id='sputnik.CompanyBuiltStatusTile__2e3nER'
            values={{ BILL_SPEND_AND_EXPENSE: PRODUCT_CONST_STRINGS.BILL_SPEND_AND_EXPENSE }}
          />
        }
        secondaryInfo={
          <FormattedMessage
            defaultMessage='Approved on {date, date, long}'
            id='sputnik.CompanyBuiltStatusTile__U5rbE9'
            values={{ date: new Date(statusUpdatedAt) }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Account created'
            id='sputnik.CompanyBuiltStatusTile__FRBgoF'
          />
        }
      >
        <StatusButtons
          hideSecondary
          primaryText={
            <FormattedMessage
              defaultMessage='Log in to your account'
              id='sputnik.CompanyBuiltStatusTile__tncgXz'
            />
          }
          onPrimaryClick={() => {
            logInfo('goToSpendAndExpense', {
              attributes: {
                creditAppId: creditApp?.salesforceCreditId,
                result: `Sending user to path: ${URL.DIVVY_PROD}`,
              },
              eventName: 'RedirectToSpend&Expense',
            })

            window.open(URL.DIVVY_PROD, '_blank', 'noopener, noreferrer')
          }}
        />
      </StatusTile>
    </div>
  )
}
export default CompanyBuiltStatusTile
